import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["balance", "rate", "months", "results", "payment", "totalInterest", "totalPaid"]

  connect() { this.calculate() }

  calculate() {
    const balance = parseFloat(this.balanceTarget.value) || 0
    const apr     = parseFloat(this.rateTarget.value) || 0
    const months  = parseInt(this.monthsTarget.value) || 0

    if (balance <= 0 || apr <= 0 || months <= 0) {
      this.resultsTarget.classList.add("hidden")
      return
    }

    const r         = apr / 100 / 12
    const payment   = balance * (r * Math.pow(1 + r, months)) / (Math.pow(1 + r, months) - 1)
    const totalPaid = payment * months
    const totalInt  = totalPaid - balance

    this.paymentTarget.textContent       = "$" + payment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    this.totalInterestTarget.textContent = "$" + Math.round(totalInt).toLocaleString()
    this.totalPaidTarget.textContent     = "$" + Math.round(totalPaid).toLocaleString()
    this.resultsTarget.classList.remove("hidden")
  }
}
